/**
 * Type for MUI boolean filter value options
 */
export type BooleanValueOption = string | { value: string | boolean; label: string }

/**
 * Transforms MUI's boolean option values from strings ('true'/'false') to actual booleans.
 * Handles case-insensitive string comparison.
 */
export const transformBooleanOption = (option: BooleanValueOption): boolean | { value: boolean; label: string } => {
  if (typeof option === 'object' && option !== null && 'value' in option) {
    const strValue = typeof option.value === 'string' ? option.value.toLowerCase() : option.value
    return {
      ...option,
      value: strValue === 'true' ? true : strValue === 'false' ? false : Boolean(option.value),
    }
  }
  const strOption = typeof option === 'string' ? option.toLowerCase() : option
  return strOption === 'true' ? true : strOption === 'false' ? false : Boolean(option)
}
